<div class="container my-3">
  <!-- <h1 class="mb-3">Add Event</h1> -->
  <form #form="ngForm" (ngSubmit)="addEventLogs()" class="mt-4">
     

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="Datetime" class="form-label">Datetime</label>
      </div>
      <div class="col-sm-4">
        <input
          type="datetime-local"
          pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}"
          class="form-control border border-dark"
          id="Datetime"
          name="Datetime"
          [(ngModel)]="addEventLogsRequest.Datetime"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="EventType" class="form-label">Event Type</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="EventType"
          name="EventType"
          [(ngModel)]="addEventLogsRequest.EventType"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="ChemicalUsed" class="form-label">Chemical Used</label>
      </div>
      <div class="col-sm-4">
        <input
          type="ChemicalUsed"
          class="form-control border border-dark"
          id="ChemicalUsed"
          name="ChemicalUsed"
          [(ngModel)]="addEventLogsRequest.ChemicalUsed"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="StartPh" class="form-label">StartPh</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="StartPh"
          name="StartPh"
          [(ngModel)]="addEventLogsRequest.StartPh"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="EndPh" class="form-label">EndPh</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="EndPh"
          name="EndPh"
          [(ngModel)]="addEventLogsRequest.EndPh"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="StartTemp" class="form-label">StartTemp</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="StartTemp"
          name="StartTemp"
          [(ngModel)]="addEventLogsRequest.StartTemp"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="EndTemp" class="form-label">EndTemp</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="EndTemp"
          name="EndTemp"
          [(ngModel)]="addEventLogsRequest.EndTemp"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="FlowRate" class="form-label">FlowRate</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="FlowRate"
          name="FlowRate"
          [(ngModel)]="addEventLogsRequest.FlowRate"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="CirculationTime" class="form-label">CirculationTime</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="CirculationTime"
          name="CirculationTime"
          [(ngModel)]="addEventLogsRequest.CirculationTime"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="SoakTime" class="form-label">SoakTime</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="SoakTime"
          name="SoakTime"
          [(ngModel)]="addEventLogsRequest.SoakTime"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="Observations" class="form-label">Observations</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="Observations"
          name="Observations"
          [(ngModel)]="addEventLogsRequest.Observations"
        />
      </div>
    </div>
    <div style="min-height: 30px"></div>
    <div class="row">
      <div class="col-sm-2" style="text-align: right">
       
      </div>
      <div class="col-sm-2" style="text-align: left">
        <button type="submit" class="btn custom-buttons-btn mt-3">Submit</button>
      </div>
    </div>
  </form>
</div>
